import React, { createContext, useContext } from "react";

export interface SDKContextValue {
  sdkReady: boolean;
}

export const SDKContext = createContext<SDKContextValue | undefined>(undefined);

export const useSDK = () => {
  const ctx = useContext(SDKContext);
  if (!ctx) throw new Error("useSDK must be used within SDKProvider");
  return ctx;
};
